/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import React from 'react';
import { authService } from '../services/authService';

const StripeOnboarding = () => {
  const [loading, setLoading] = React.useState(false);

  const handleOnboard = async () => {
    setLoading(true);
    try {
      const response = await authService.onboardStripe();
      if (response.data.status === 'success') {
        window.location.href = response.data.onboardingUrl;
      }
    } catch (error) {
      console.error('Onboarding error', error);
      alert('Failed to start onboarding');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md border border-gray-200">
      <h2 className="text-2xl font-bold mb-4">Start Selling</h2>
      <p className="text-gray-600 mb-6">
        Set up your Stripe Connect account to start receiving payments for your items. 
        We use Stripe Connect Express for fast and secure payouts.
      </p>
      <button
        onClick={handleOnboard}
        disabled={loading}
        className="px-6 py-2 bg-indigo-600 text-white font-semibold rounded-md hover:bg-indigo-700 disabled:opacity-50 transition-colors"
      >
        {loading ? 'Setting up...' : 'Connect Stripe Account'}
      </button>
    </div>
  );
};

export default StripeOnboarding;
